import React from "react";
import Subscriber from "../../subscriber.class";
import Storage from "../../services/storage.service";

export default class BodyClasses extends Subscriber {

  state = {
    modal_open: false
  }

  componentDidMount() {
    this.subscriptions.push(
      Storage.get_obsrv("modal_open").subscribe((modal_type) => {
        this.setState({
          modal_open: modal_type
        });
      })
    );
  }

  componentWillUnmount() {
    if (this.subscriptions) {
      for (let subscription of this.subscriptions) {
        subscription.unsubscribe();
      }
    }
  }

  render() {
    let classes = [];
    if(this.state.modal_open){
      classes.push("vmo-bc-modal vmo-bc-modal-" + this.state.modal_open);
    }

    return (
      <div className={"vmo-bc " + classes.join()}>
      </div>
    );
  }
}

